
(function () {
  const langs = {
    en: {
      kids_size: "Kids Size",
      title: 'How to measure',
      step1: 'Bust',
      step1_desc: 'With arms relaxed down at the sides, measure the fullest part of the bust, keeping the tape parallel to the floor.',
      step2: 'Waist',
      step2_desc: 'Measure around your natural waistline, which is the smallest area of the waist.',
      step3: 'Hips',
      step3_desc: 'Stand with feet together. Keep the tape straight and parallel to the floor. Measure around the fullest part.',
      step4: 'Leg length',
      step4_desc: 'Stand shoeless on a flat surface and measure from the side of your hip bone to the inside of your ankle using a measuring tape.',
      step5: 'Height',
      step5_desc: 'Remove shoes, stand against a wall with your back touching it, ensuring your heels, buttocks, shoulders, and the back of your head make contact with the wall.',
    },
    de: {
      kids_size: "Kindergrößen",
      "title": "So messen Sie richtig",
      "step1": "Brustumfang",
      "step1_desc": "Mit entspannt herabhängenden Armen messen Sie den vollsten Teil der Brust und halten das Maßband parallel zum Boden.",
      "step2": "Taillenumfang",
      "step2_desc": "Messen Sie Ihre natürliche Taille, also die schmalste Stelle der Taille.",
      "step3": "Hüftumfang",
      "step3_desc": "Stellen Sie sich mit geschlossenen Füßen hin. Halten Sie das Maßband gerade und parallel zum Boden und messen Sie den vollsten Teil.",
      "step4": "Beinlänge",
      "step4_desc": "Stehen Sie barfuß auf einer ebenen Fläche und messen Sie vom seitlichen Hüftknochen bis zur Innenseite des Knöchels mit einem Maßband.",
      "step5": "Körpergröße",
      "step5_desc": "Ziehen Sie die Schuhe aus und stellen Sie sich mit dem Rücken an eine Wand, sodass Fersen, Gesäß, Schultern und Hinterkopf die Wand berühren."
    },
    es: {
      kids_size: "Tallas para niños",
      "title": "Cómo medir",
      "step1": "Busto",
      "step1_desc": "Con los brazos relajados a los lados, mida la parte más llena del busto manteniendo la cinta métrica paralela al suelo.",
      "step2": "Cintura",
      "step2_desc": "Mida alrededor de su cintura natural, que es la parte más estrecha.",
      "step3": "Caderas",
      "step3_desc": "Párese con los pies juntos. Mantenga la cinta recta y paralela al suelo. Mida alrededor de la parte más llena.",
      "step4": "Largo de pierna",
      "step4_desc": "De pie y sin zapatos sobre una superficie plana, mida desde el lateral de la cadera hasta la parte interna del tobillo con una cinta métrica.",
      "step5": "Altura",
      "step5_desc": "Quítese los zapatos y colóquese contra una pared con la espalda apoyada, asegurándose de que los talones, glúteos, hombros y la parte posterior de la cabeza toquen la pared."
    },
    fr: {
      kids_size: "Tailles enfants",
      "title": "Comment mesurer",
      "step1": "Poitrine",
      "step1_desc": "Avec les bras détendus le long du corps, mesurez la partie la plus large de la poitrine en gardant le mètre ruban parallèle au sol.",
      "step2": "Taille",
      "step2_desc": "Mesurez votre tour de taille naturel, qui correspond à la partie la plus étroite.",
      "step3": "Hanches",
      "step3_desc": "Tenez-vous debout, les pieds joints. Gardez le mètre ruban droit et parallèle au sol. Mesurez la partie la plus large.",
      "step4": "Longueur de jambe",
      "step4_desc": "Debout sans chaussures sur une surface plane, mesurez du côté de la hanche jusqu'à l'intérieur de la cheville avec un mètre ruban.",
      "step5": "Taille (hauteur)",
      "step5_desc": "Retirez vos chaussures, tenez-vous contre un mur avec le dos appuyé, en veillant à ce que les talons, les fesses, les épaules et l'arrière de la tête touchent le mur."
    }
  }
  const lang = window.Shopify.locale || 'en';
  const i18nText = langs[lang] || langs['en'];
  let sizeChartData = null
  let defaultGrouptype = ''
  let defaultRoleType = ''
  const sizeChartTableContainer = document.querySelector('[data-size-chart-table-container]');
  const oldSizeChartEl = document.querySelector('.old-size-chart');
  const placeholderSizeTableEl = document.querySelector('.placeholder-size-table');
  function sizeChartTableScrollTop () {
    const scrollContainer = document.querySelector('[data-size-chart]')
    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
  function createSizeChartTable(currentRole) {
    const headerList = currentRole.headerList || [];
    const rowList = currentRole.rowList || [];
    const tableWrap = sizeChartTableContainer.querySelector('.size-chart-table-wrap')
    if (tableWrap) {
      tableWrap.innerHTML = `
        <table class="size-chart-table-head size-chart-table">
          <thead>
            <tr>
              <th>
                ${headerList[0] || ''}
              </th>
            </tr>
          </thead>
          <tbody>
              ${rowList.map((cell, i) => {
                return`
                <tr>
                  <td>${cell[0]}</td>
                </tr>
              `
              }).join('')}
          </tbody>
        </table>
        <div class="size-chart-table-body-wrap">
          <table class="size-chart-table">
            <thead>
              <tr>
                ${headerList.map(head => `<th>${head}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${rowList.map((cell, i) => {
                  return`
                  <tr>
                    ${cell.map(c => `<td>${c}</td>`).join('')}
                  </tr>
                `
                }).join('')}
            </tbody>
          </table>
        </div>
      `;
    }
    setTimeout(sizeChartTableScrollTop, 100);
  }

  function resetRoleTable(roleKey = '') {
    currentGroup = sizeChartData.find(group => group.groupKey === defaultGrouptype);
    if (currentGroup) {
      const roleEl = sizeChartTableContainer.querySelector('.size-chart-change-role')
      roleEl.innerHTML = '';
      const currentRole = currentGroup.roleList.find(role => role.roleKey === roleKey) || currentGroup.roleList[0]
      if (currentRole) {
        defaultRoleType = currentRole.roleKey;
      }
      const roleBtns = currentGroup.roleList.map(item => {
        const roleBtn = document.createElement('button');
        roleBtn.innerText = item.roleName;
        roleBtn.dataset.groupKey = item.roleKey;
        roleBtn.classList.add('size-chart-change-role-btn');
        if (item.roleKey === defaultRoleType) {
          roleBtn.classList.add('active');
        }
        return roleBtn
      })
      if (roleBtns.length > 1) {
        roleBtns.forEach(btn => {
          btn.addEventListener('click', () => {
            roleBtns.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            defaultRoleType = btn.dataset.groupKey
            createSizeChartTable(currentGroup.roleList.find(role => role.roleKey === defaultRoleType) || currentGroup.roleList[0])
          })
          roleEl.appendChild(btn)
        })
      }
      createSizeChartTable(currentRole)
    }
  }
  function createChangeGroup(el) {
    const btns = sizeChartData.map(item => {
      const groupItem = document.createElement('button');
      groupItem.innerText = item.groupName;
      groupItem.dataset.groupKey = item.groupKey;
      groupItem.classList.add('size-chart-change-group-item');
      if (item.groupKey === defaultGrouptype) {
        groupItem.classList.add('active');
      }
      return groupItem
    })
    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        defaultGrouptype = btn.dataset.groupKey
        resetRoleTable(defaultRoleType || '')
      })
      el.appendChild(btn)
    });
    resetRoleTable('')
  }
  function sizeChartFooter() {
    return `
      <div class="size-chart-footer">
        <div class="size-chart-footer-title">${i18nText.title}</div>
        <div class="size-chart-footer-main">
          <img class="how_to_measure" src="https://cdn.shopify.com/s/files/1/0705/3885/4643/files/20260331-161633.png?v=1775631092" alt="How to measure" />
          <div class="size-chart-footer-content">
            <div class="size-chart-footer-item">
              <p class="size-chart-footer-item-title"><span>1</span>${i18nText.step1}</p>
              <p class="size-chart-footer-item-desc">${i18nText.step1_desc}</p>
            </div>
            <div class="size-chart-footer-item">
              <p class="size-chart-footer-item-title"><span>2</span>${i18nText.step2}</p>
              <p class="size-chart-footer-item-desc">${i18nText.step2_desc}</p>
            </div>
            <div class="size-chart-footer-item">
              <p class="size-chart-footer-item-title"><span>3</span>${i18nText.step3}</p>
              <p class="size-chart-footer-item-desc">${i18nText.step3_desc}</p>
            </div>
            <div class="size-chart-footer-item">
              <p class="size-chart-footer-item-title"><span>4</span>${i18nText.step5}</p>
              <p class="size-chart-footer-item-desc">${i18nText.step5_desc}</p>
            </div>
          </div>
        </div>
      </div>
    `
  }
  function initSizeChart() {
    sizeChartTableContainer.innerHTML = `
      <div class="size-chart-change-head">
        <div class="size-chart-change-gruop"></div>
        <div class="size-chart-change-role"></div>
      </div>
      <div class="size-chart-table-wrap"></div>
      ${sizeChartFooter()}
    `;
    setTimeout(() => {
      const gruopEl = sizeChartTableContainer.querySelector('.size-chart-change-gruop');
      const headEl = sizeChartTableContainer.querySelector('.size-chart-change-head');
      if (sizeChartData.length > 1) {
        createChangeGroup(gruopEl);
      } else {
        if (sizeChartData[0].roleList.length > 1) {
          gruopEl.innerHTML = '<p class="size-chart-change-gruop-title">' + i18nText.kids_size + '</p>';
          headEl.classList.add('size-chart-change-head-kids');
        } else {
          headEl.style.display = 'none';
        }
        resetRoleTable('')
      }
    }, 100);
    if (oldSizeChartEl) {
      oldSizeChartEl.style.display = 'none';
    }
  }
  async function getSizeChartData(id) {
    try{
      const res = await window.apiRequest.get('/v1/product/size_chart', {shopifyProductId: id})
      // const res = await window.apiRequest.get('https://shopify-api.alpha.patpat.vip/v1/product/size_chart', {shopifyProductId: id})
      console.log(res, 'size chart data');
      if (res && res.code === 200 && res.data && res.data.groupList.length > 0) {
        sizeChartData = res.data.groupList;
        defaultGrouptype = res.data.groupList[0].groupKey
        defaultRoleType = (res.data.groupList[0].roleList[0] || {}).roleKey || ''
        initSizeChart();
      } else {
        if (oldSizeChartEl) {
          oldSizeChartEl.style.display = 'block';
        }
      }
      placeholderSizeTableEl && placeholderSizeTableEl.remove();
    } catch (error) {
      placeholderSizeTableEl && placeholderSizeTableEl.remove();
      if (oldSizeChartEl) {
        oldSizeChartEl.style.display = 'block';
      }
      console.log('Error fetching size chart data:', error);
    }
  }
  const urlObj = new URL(window.location.href)
  let productId = urlObj.searchParams.get('shopifyProductId')
  if (sizeChartTableContainer && sizeChartTableContainer.dataset.sizeChartTableContainer) {
    productId = sizeChartTableContainer.dataset.sizeChartTableContainer
  }
  productId && getSizeChartData(productId);
})();
